export default {"src":"/_next/static/media/logo_bf_1_yl.d8072554.svg","height":36,"width":219,"blurWidth":0,"blurHeight":0};